export enum EEnergyNeedEditParameter {
  TITLE = "TITLE",
  MONTHLY_ENERGY_NEED = "MONTHLY_ENERGY_NEED",
  MAX_POWER = "MAX_POWER",
  DISCHARGE_RATE = "DISCHARGE_RATE",
  NIGHT_LOAD = "NIGHT_LOAD",
  SUNLIGHT_HOURS = "SUNLIGHT_HOURS",
  NO_OF_USERS = "NO_OF_USERS",
  DEMAND_PER_USER = "DEMAND_PER_USER",
  AUTONOMY_DAYS = "AUTONOMY_DAYS",
  UTILITY = "UTILITY",
}
